import { useQuery } from '@tanstack/react-query';
import { api } from './api';
import { CHAVES_DE_ACESSO, rotuloDaChave } from './dominio';

/**
 * As chaves de acesso que existem hoje, para os seletores do backoffice.
 *
 * **São duas famílias, e por isso o seletor é agrupado** (D-44/D-45): as
 * **fixas** nomeiam capacidade e estão escritas no código dos dois lados; as de
 * **lei** nomeiam uma Legislação Comentada pelo id, nascem quando alguém importa
 * uma lei e mudam sem deploy. Uma lista só, com quarenta leis misturadas ao
 * "Enac", esconderia justamente a distinção que decide o preço.
 *
 * O rótulo da lei sai da própria lista de leis do acervo - a mesma consulta que
 * a tela de Legislação Comentada usa -, e não de um mapa escrito aqui: um mapa
 * no bundle não tem como saber que `commented_law:<uuid>` é a Lei de Registros
 * Públicos.
 */
export interface GrupoDeChaves {
  label: string;
  options: { value: string; label: string }[];
}

export function useOpcoesDeChave(): { grupos: GrupoDeChaves[]; carregando: boolean } {
  const leis = useQuery({ queryKey: ['leis-do-acervo'], queryFn: () => api.listAdminLaws() });

  const fixas: GrupoDeChaves = {
    label: 'Acesso do produto',
    options: CHAVES_DE_ACESSO.map((chave) => ({ value: chave, label: rotuloDaChave(chave) })),
  };

  /*
   * Só as **publicadas**: conceder o comentário de uma lei que o aluno não pode
   * nem abrir seria vender uma porta para um lugar que não existe. A lei entra
   * na lista no dia em que for publicada.
   */
  const publicadas = (leis.data ?? []).filter((lei) => lei.publicada);

  const deLeis: GrupoDeChaves = {
    label: 'Legislações Comentadas',
    options: publicadas.map((lei) => ({ value: lei.chave, label: lei.title })),
  };

  return {
    grupos: deLeis.options.length > 0 ? [fixas, deLeis] : [fixas],
    carregando: leis.isPending,
  };
}
